import { useNavigate } from 'react-router';
import { Box, Button } from '@chakra-ui/react';

import { useTranslation } from 'helpers/languages/translations';

import PageHeader from 'layout/pageHeader';
import { ArrowUpIcon } from '@chakra-ui/icons';
import { useTabNavigate } from 'router/tabsMapper';
import ClusterManagementTabs from './ClusterManagementTabs';

const PATH = 'cluster-management';
const ID = 'cdm_cluster_management';
const NAME = 'page.clusterManagement';

const tabs = ['shop-cluster', 'cluster', 'product-cluster'];

const ClusterManagement = () => {
    const translate = useTranslation();
    const navigate = useNavigate();
    const { tabIndex, setTabIndex } = useTabNavigate('cluster-management');

    return (
        <Box>
            <PageHeader icon={{ name: 'secto' }} pageTitle={translate(`${tabs[tabIndex]}.header`) as string}>
                <Button
                    onClick={() => {
                        navigate('./upload');
                    }}
                    fontSize="14px"
                    h="30px"
                    bg={'white'}
                    variant="outline"
                    leftIcon={<ArrowUpIcon />}
                >
                    {translate('users.upload.users')}
                </Button>
            </PageHeader>
            <Box px="32px">
                <ClusterManagementTabs setTabIndex={setTabIndex} index={tabIndex} />
            </Box>
        </Box>
    );
};

export { PATH, ID, NAME };
export default ClusterManagement;
